import Vue from "vue";
import CsmlMonacoEditor from "@clevy/vue-csml-monaco";
import App from "./App.vue";
import { registerLicense } from '@syncfusion/ej2-base';


Vue.use(CsmlMonacoEditor);


import "./assets/main.css";

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2UVhhQlVCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Sd01iW31bcHJSQWld');

new Vue({
  render: (h) => h(App),
}).$mount("#app");
